import { _mock } from './_mock';

// ----------------------------------------------------------------------

const NAME = [
  'Apple iPhone',
  'Samsung Galaxy',
  'Nike Air Max',
  'Adidas Ultraboost',
  'Sony PlayStation',
  'Microsoft Surface',
  'Tesla Model S',
  'Amazon Echo',
  'Google Pixel',
  'Bose QuietComfort',
  'Canon EOS',
  'HP Spectre',
  'LG OLED',
  'Rolex Submariner',
  'Chanel No.5',
  'Louis Vuitton Speedy',
  'Gucci Ace',
  'Ray-Ban Aviator',
  'Herschel Little America',
  'Le Creuset Dutch Oven',
  'Yeti Tumbler',
  'Patagonia Nano Puff',
  'Lululemon Align Leggings',
  'Allbirds Wool Runners',
];

const CATEGORIES = [
  'Electronics',
  'Fashion and Apparel',
  'Home and Garden',
  'Beauty and Personal Care',
  'Health and Wellness',
  'Toys and Games',
  'Sports and Outdoors',
  'Baby and Kids',
  'Automotive and Industrial',
  'Pet Supplies',
  'Food and Beverage',
  'Office and School Supplies',
  'Jewelry and Accessories',
  'Arts and Crafts',
  'Books and Media',
  'Travel and Luggage',
  'Gifts and Flowers',
  'Musical Instruments',
  'Party Supplies',
  'Business and Industrial Supplies',
  'Tools and Hardware',
  'Electronics Accessories',
  'Furniture and Decor',
  'Computer and Software',
];

const DESCRIPTION = `
<p>Aenean viverra rhoncus pede. Etiam feugiat lorem non metus. Quisque malesuada placerat nisl.</p>

<br/>
<ul>
  <li> Updated with a more matte texture, perfect for casual styling. </li>
  <li> Durable water-repellent coating. </li>
  <li> dsdsds </li>
  <li> dsdsds </li>
  <li> Anti-static lining. </li>
</ul>
<br/>

<p>Living in today’s metropolitan world of cellular phones, mobile computers and other high-tech gadgets is not just hectic but very impersonal. We make money and then invest our time and effort in making more money..</p>
`;

// ----------------------------------------------------------------------

export const _productsTable = [...Array(12)].map((_, index) => ({
  id: _mock.id(index),
  orderId: `#011120${index + 1}`,
  item: NAME[index],
  deliveryDate: _mock.time(index),
  price: _mock.number.price(index),
  status: ['Completed', 'To Process', 'Cancelled', 'Return'][index] || 'Completed',
}));

// export const _productsCarousel = [...Array(4)].map((_, index) => ({
//   id: _mock.id(index),
//   title: _mock.productName(index),
//   caption: _mock.description(index),
//   coverUrl: _mock.image.product(index),
//   label: 'Opening Sale Discount 50%',
// }));
export const _productsCarousel = [...Array(4)].map((_, index) => ({
  id: `edu-product-${index + 1}`,
  title: [
    'Sản phẩm TT 37,38,39 theo chuẩn Bộ GD&ĐT',
    'Bộ đồ dùng học tập mầm non',
    'Bảng tương tác thông minh',
    'Bộ thiết bị STEM – Robotics cơ bản',
  ][index],
  caption: [
    'Sản phẩm TT 37,38,39 theo chuẩn Bộ GD&ĐT bao gồm: Thiết bị đóng bộ, thiết bị điện tử, thiết bị thí nghiệm,...',
    'Bộ dụng cụ học tập chất lượng cao dành cho trẻ mầm non, an toàn và bền bỉ.',
    'Màn hình cảm ứng đa điểm hỗ trợ giảng dạy trực quan và sinh động.',
    'Bộ STEM giúp học sinh phát triển tư duy logic và kỹ năng công nghệ.',
  ][index],
  coverUrl: [
    '/assets/images/carousel/373839.png',
    '/assets/images/carousel/mamnon.png',
    '/assets/images/carousel/bangtuongtac.png',
    '/assets/images/carousel/stem.png',
  ][index],
  label: 'Ưu đãi khai trương – Giảm 20%',
}));

export const _productsCompare = [
  'Apple iPhone 12 Pro',
  'Apple iPhone 13 Pro',
  'Apple iPhone 14 Pro',
].map((name, index) => ({
  id: _mock.id(index),
  name,
  price: _mock.number.price(index),
  coverUrl: _mock.image.product(4),
  ratingNumber: _mock.number.rating(index),
  details: (index === 0 && [
    'Super Retina XDR (OLED)',
    'Up to 29 hours video playback',
    'A14 Bionic',
    'True Tone',
    'IP68',
    '2017',
  ]) || ['Super Retina XDR (OLED)', '', 'A14 Bionic', '', 'IP68', '2017'],
}));

export const _products = [...Array(24)].map((_, index) => ({
  id: _mock.id(index),
  stock: 100,
  name: NAME[index],
  description: DESCRIPTION,
  category: CATEGORIES[index],
  price: _mock.number.price(index),
  sold: _mock.number.nativeM(index),
  caption: _mock.description(index),
  coverUrl: _mock.image.product(index),
  ratingNumber: _mock.number.rating(index),
  totalReviews: _mock.number.nativeL(index),
  label: ['sale', 'new', 'sale', 'sale'][index] || '',
  priceSale:
    [
      _mock.number.price(1),
      _mock.number.price(2),
      _mock.number.price(3),
      _mock.number.price(4),
      _mock.number.price(5),
    ][index] || 0,
  images: [
    _mock.image.product(1),
    _mock.image.product(2),
    _mock.image.product(3),
    _mock.image.product(4),
    _mock.image.product(5),
    _mock.image.product(6),
    _mock.image.product(7),
    _mock.image.product(8),
  ],
}));

export const productsEdu = [
  {
    id: '1',
    name: 'Bảng Tương Tác Thông Minh 75 inch',
    sold: 58,
    label: 'sale',
    price: 34500000,
    caption: 'Bảng tương tác cảm ứng đa điểm dành cho lớp học thông minh.',
    stock: 120,
    coverUrl: 'https://placehold.co/600x400?text=Interactive+Board+75',
    category: 'dung-chung',
    images: [
      'https://placehold.co/600x400?text=Interactive+1',
      'https://placehold.co/600x400?text=Interactive+2',
    ],
    priceSale: 32900000,
    ratingNumber: 4.8,
    description:
      'Bảng tương tác 75 inch hỗ trợ cảm ứng đa điểm, tích hợp phần mềm giảng dạy hiện đại.',
    totalReviews: 112,
  },
  {
    id: '2',
    name: 'Máy Chiếu Epson XGA 3800 Lumens',
    sold: 44,
    label: 'sale',
    price: 12900000,
    caption: 'Máy chiếu độ sáng cao cho lớp học và phòng họp.',
    stock: 200,
    coverUrl: 'https://placehold.co/600x400?text=Projector+Epson',
    category: 'dung-chung',
    images: [
      'https://placehold.co/600x400?text=Projector+1',
      'https://placehold.co/600x400?text=Projector+2',
    ],
    priceSale: 11500000,
    ratingNumber: 4.7,
    description: 'Máy chiếu Epson XGA công suất sáng 3800 lumens, hỗ trợ trình chiếu rõ nét.',
    totalReviews: 89,
  },
  {
    id: '3',
    name: 'Laptop Lenovo IdeaPad 14',
    sold: 132,
    label: 'THCS',
    price: 8900000,
    caption: 'Laptop học tập giá tốt cho học sinh – sinh viên.',
    stock: 150,
    coverUrl: 'https://placehold.co/600x400?text=Lenovo+IdeaPad',
    category: 'thcs',
    images: [
      'https://placehold.co/600x400?text=Lenovo+1',
      'https://placehold.co/600x400?text=Lenovo+2',
    ],
    priceSale: 0,
    ratingNumber: 4.6,
    description: 'Laptop 14 inch CPU i3, RAM 8GB, SSD 256GB, tối ưu học tập và văn phòng.',
    totalReviews: 204,
  },
  {
    id: '4',
    name: 'Micro Không Dây Cho Giáo Viên',
    sold: 155,
    label: '',
    price: 1290000,
    caption: 'Micro không dây chất lượng cao dành cho giảng dạy.',
    stock: 300,
    coverUrl: 'https://placehold.co/600x400?text=Wireless+Mic',
    category: 'dung-chung',
    images: ['https://placehold.co/600x400?text=Mic+1', 'https://placehold.co/600x400?text=Mic+2'],
    priceSale: 0,
    ratingNumber: 4.5,
    description: 'Bộ micro không dây với khả năng thu âm rõ và xuyên suốt, phù hợp cho lớp học.',
    totalReviews: 67,
  },
  {
    id: '5',
    name: 'Loa Bluetooth Phòng Học 60W',
    sold: 73,
    label: 'sale',
    price: 2590000,
    caption: 'Loa công suất lớn phục vụ giảng dạy và thuyết trình.',
    stock: 80,
    coverUrl: 'https://placehold.co/600x400?text=Bluetooth+Speaker',
    category: 'dung-chung',
    images: [
      'https://placehold.co/600x400?text=Speaker+1',
      'https://placehold.co/600x400?text=Speaker+2',
    ],
    priceSale: 2390000,
    ratingNumber: 4.3,
    description: 'Loa 60W chất lượng cao, kết nối Bluetooth, phù hợp cho phòng học và sự kiện.',
    totalReviews: 41,
  },
  {
    id: '6',
    name: 'Bút Trình Chiếu Laser',
    sold: 180,
    label: '',
    price: 290000,
    caption: 'Bút trình chiếu chuyên dụng cho giáo viên.',
    stock: 500,
    coverUrl: 'https://placehold.co/600x400?text=Laser+Pointer',
    category: 'van-phong-pham',
    images: [
      'https://placehold.co/600x400?text=Laser+1',
      'https://placehold.co/600x400?text=Laser+2',
    ],
    priceSale: 0,
    ratingNumber: 4.4,
    description: 'Bút trình chiếu laser kết nối USB/Bluetooth, hỗ trợ giảng dạy và thuyết trình.',
    totalReviews: 52,
  },
  {
    id: '7',
    name: 'Bàn Giáo Viên Gỗ MDF',
    sold: 21,
    label: '',
    price: 2350000,
    caption: 'Bàn giáo viên gỗ MDF chống trầy xước.',
    stock: 110,
    coverUrl: 'https://placehold.co/600x400?text=Teacher+Desk',
    category: 'dung-chung',
    images: [
      'https://placehold.co/600x400?text=Desk+1',
      'https://placehold.co/600x400?text=Desk+2',
    ],
    priceSale: 0,
    ratingNumber: 4.2,
    description: 'Bàn giáo viên chuẩn trường học với thiết kế bền đẹp, tiện dụng.',
    totalReviews: 17,
  },
  {
    id: '8',
    name: 'Ghế Học Sinh Chống Gù',
    sold: 201,
    label: '',
    price: 790000,
    caption: 'Ghế công thái học giúp ngồi đúng tư thế.',
    stock: 250,
    coverUrl: 'https://placehold.co/600x400?text=Student+Chair',
    category: 'mam-non',
    images: [
      'https://placehold.co/600x400?text=Chair+1',
      'https://placehold.co/600x400?text=Chair+2',
    ],
    priceSale: 0,
    ratingNumber: 4.6,
    description: 'Ghế học sinh chống gù lưng với thiết kế hỗ trợ cột sống, phù hợp mọi lứa tuổi.',
    totalReviews: 128,
  },
  {
    id: '9',
    name: 'Bộ Thí Nghiệm Hóa Học Cấp 3',
    sold: 62,
    label: '',
    price: 3690000,
    caption: 'Bộ dụng cụ thí nghiệm chuẩn THPT.',
    stock: 140,
    coverUrl: 'https://placehold.co/600x400?text=Chemistry+Kit',
    category: 'stem',
    images: [
      'https://placehold.co/600x400?text=ChemKit+1',
      'https://placehold.co/600x400?text=ChemKit+2',
    ],
    priceSale: 0,
    ratingNumber: 4.7,
    description: 'Bộ thí nghiệm hóa học bao gồm đầy đủ dụng cụ cho phòng lab trường THPT.',
    totalReviews: 91,
  },
  {
    id: '10',
    name: 'Máy Tính Khoa Học Casio FX-580VN X',
    sold: 310,
    label: 'new',
    price: 520000,
    caption: 'Máy tính khoa học hỗ trợ 521 chức năng.',
    stock: 95,
    coverUrl: 'https://placehold.co/600x400?text=Casio+FX580',
    category: 'van-phong-pham',
    images: [
      'https://placehold.co/600x400?text=Casio+1',
      'https://placehold.co/600x400?text=Casio+2',
    ],
    priceSale: 0,
    ratingNumber: 4.9,
    description:
      'Máy tính Casio FX-580VN X được dùng rộng rãi tại Việt Nam, phù hợp mọi khối lớp THCS – THPT.',
    totalReviews: 342,
  },
];
